document.addEventListener('DOMContentLoaded', () => {

    // Burger Button
    const toggler = document.getElementById('navbar-toggler');
    if(toggler){
        toggler.addEventListener('click', () => {
            toggler.classList.toggle("is-active");
        });
    }


    //Hover für Dropdowns
    const dropdowns = document.querySelectorAll('.dropdown-link');
    dropdowns.forEach((item) => {
        const submenu = item.querySelector('.hover-menu');

        if (submenu) {
            item.addEventListener('mouseenter', () => {
                submenu.classList.remove('visually-hidden');
            });

            item.addEventListener('mouseleave', () => {
                submenu.classList.add('visually-hidden');
            });
        }
    });
});
